module.exports = __webpack_public_path__ + "img/panels_serial01.79404d10.gif";